import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/inspections/[id]/summary/page";

export const Route = createFileRoute("/inspections/$id/summary")({
  component: Page,
});
